"use client";

import { useEffect, useState } from "react";

import GoogleAdsenseUnit from "./google_adsense_unit";
import styles from "./ads.module.css";

type SidebarRailAdsenseProps = {
	slot?: string;
	label?: string;
	fixedSize?: boolean;
};

/** PCだけで広告を初期化する。枠の高さはCSSで先に確保し、読み込みでランキングが移動するのを防ぐ。 */
export default function SidebarRailAdsense({
	slot,
	label = "スポンサーリンク",
	fixedSize = false,
}: SidebarRailAdsenseProps) {
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(fixedSize
			? "(min-width: 1024px) and (hover: hover) and (pointer: fine)"
			: "(min-width: 1024px)");
		const sync = () => setIsDesktop(mediaQuery.matches);

		sync();
		mediaQuery.addEventListener("change", sync);

		return () => mediaQuery.removeEventListener("change", sync);
	}, [fixedSize]);

	if (!slot) {
		return null;
	}

	return (
		<section
			className={`${styles.sidebarCard} ${styles.sidebarAdCard} ${styles.desktopOnly} ${fixedSize ? styles.sidebarSquareCard : ""}`}
			aria-label={label}
		>
			<p className={styles.sidebarLabel}>{label}</p>
			<div className={fixedSize ? styles.sidebarSquareFrame : styles.sidebarRailFrame}>
				{isDesktop && <GoogleAdsenseUnit
					slot={slot}
					className={styles.sidebarRailAd}
					style={fixedSize
						? { display: "block", width: "250px", height: "250px" }
						: { display: "block", width: "100%", minHeight: "250px" }}
					format={fixedSize ? null : "auto"}
					fullWidthResponsive={fixedSize ? null : false}
				/>}
			</div>
		</section>
	);
}
